export const LoadMore = (
  setPage,
  setPerPage,
  fetchData,
  tab,
  page,
  perPage
) => {
  const options = {
    sortDirection: null,
    selectedColumn: null,
    perPage: perPage,
    page: page + 1
  }

  setPage(page + 1)
  fetchData(options, tab)
}
